import React, { useMemo } from 'react'
import { AutoSizer, CellMeasurer, CellMeasurerCache, List, ListRowProps } from 'react-virtualized'
import type { GroupBase, MenuListProps } from 'react-select'
import { WordItem } from "ap-exerciser-sdk/models";


export default function VirtualizedList<ListOption extends WordItem>({
                                                                       children,
                                                                       ...props
                                                                     }: MenuListProps<ListOption, false, GroupBase<ListOption>>) {
  const rows = children

  const cellCache = useMemo(() => {
    return new CellMeasurerCache({
      fixedWidth: true,
      fixedHeight: true,
      defaultWidth: 300,
      defaultHeight: 38,
    })
  }, [])

  if (!Array.isArray(rows)) {
    // For children like: "Loading" or "No Options" provided by 'react-select'
    return <>{children}</>
  }

  const rowRenderer = ({ key, parent, index, style }: ListRowProps) => (
    <CellMeasurer cache={cellCache} key={key} columnIndex={0} rowIndex={index} parent={parent}>
      <div key={key} style={style}>
        {rows[index]}
      </div>
    </CellMeasurer>
  )

  return (
    // <div className={"APSelect"}
    //      style={{ display: "flex", width: "100%", height: "auto", minHeight: "30px", maxHeight: "300px" }}>
    <AutoSizer defaultHeight={props.maxHeight} style={{
      maxHeight: props.maxHeight,
      minHeight: Math.min(cellCache.getHeight(0, 0) * rows.length, props.maxHeight)
    }}
               children={({ width, height }) => (
                 <List
                   width={width}
                   height={height}
                   deferredMeasurementCache={cellCache}
                   rowHeight={cellCache.rowHeight}
                   rowCount={rows.length}
                   rowRenderer={rowRenderer}
                 />
               )} />
    // </div>
  )
}
